import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import type { Document } from '@/types'

export function useDocuments(filter: { category?: string; program?: string; divisi?: string }) {
  const [documents, setDocuments] = useState<Document[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    let q = supabase.from('documents').select('*').order('created_at', { ascending: false })

    if (filter.category) q = q.eq('category', filter.category)
    if (filter.program)  q = q.ilike('program', filter.program)
    if (filter.divisi)   q = q.ilike('divisi', filter.divisi)

    q.then(({ data }) => {
      setDocuments(data ?? [])
      setLoading(false)
    })
  }, [filter.category, filter.program, filter.divisi])

  return { documents, loading }
}
